export default __webpack_public_path__ + "static/media/dealer-1.6339e52a.png";